import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Link from 'gatsby-link'

import { withStyles } from 'material-ui/styles'
import Grid from 'material-ui/Grid';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography/Typography';

import * as SiteConfig from '../../config/Config'

const styles = theme => ({
  // background: bg - color bg-image position/bg-size bg-repeat bg-origin bg-clip bg-attachment initial|inherit;
  banner: {
    background: SiteConfig.pages.home.banner.image ? `${theme.palette.primary.main} url(${SiteConfig.pages.home.banner.image}) center center/cover fixed` : `${theme.palette.primary.main}`,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      paddingTop: `${SiteConfig.headerLogo.large.height * 2.5}px`,
      paddingBottom: `${SiteConfig.headerLogo.large.height * 2.5}px`,
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: `${SiteConfig.headerLogo.large.height + SiteConfig.headerLogo.large.verticalPadding}px`,
      paddingBottom: `${SiteConfig.headerLogo.large.height + SiteConfig.headerLogo.large.verticalPadding}px`,
    },
  },
  // banner: {
  //   background: SiteConfig.pages.home.banner.image ? `${theme.palette.primary.main} url(${SiteConfig.pages.home.banner.image}) center center/cover fixed` : `${theme.palette.primary.main}`,
  //   textAlign: 'center',

  //   // [theme.breakpoints.up('lg')]: {
  //   //   backgroundColor: 'red'
  //   // },
  //   // [theme.breakpoints.only('md')]: {
  //   //   backgroundColor: 'green'
  //   // },
  //   // [theme.breakpoints.only('sm')]: {
  //   //   backgroundColor: 'pink'
  //   // },
  //   // [theme.breakpoints.only('xs')]: {
  //   //   backgroundColor: 'yellow',
  //   //   height: '100vh'
  //   // },

  //   [theme.breakpoints.up('md')]: {
  //     paddingTop: `${SiteConfig.headerLogo.large.height * 2.5}px`,
  //     paddingBottom: `${SiteConfig.headerLogo.large.height * 2.5}px`,
  //   },
  //   [theme.breakpoints.down('md')]: {
  //     paddingTop: `${SiteConfig.headerLogo.large.height + SiteConfig.headerLogo.large.verticalPadding}px`,
  //     paddingBottom: `${SiteConfig.headerLogo.large.height + SiteConfig.headerLogo.large.verticalPadding}px`,
  //   },
  // },
  link: {
    textDecoration: "none",
  },
  title: {
    color: theme.palette.secondary.light,
  },
  subTitle: {
    color: theme.palette.common.white,
  },
})

const HomeBanner = ({
  classes,
  title,
  subTitle,
  action
}) =>
  <Grid
    item
    xs={12}
    className={classes.banner}
  >
  
    {title &&
      <Typography
        variant="display3"
        className={classes.title}
      >
        {title}
      </Typography>}

    {subTitle &&
      <Typography
        variant="headline"
        gutterBottom
        className={classes.subTitle}
      >
        {subTitle}
      </Typography>}

    {action &&
      <Link
        to={action.url}
        className={classes.link}
      >
        <Button
          variant="raised"
          color="secondary"
        >
          {action.text}
        </Button>
      </Link>}

  </Grid>

HomeBanner.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  action: PropTypes.object,
};

export default withStyles(styles)(HomeBanner)


// WEBPACK FOOTER //
// ./src/components/HomeBanner/index.js